import React, { useState } from 'react';

interface InputProps {
  type?: 'text' | 'email' | 'password' | 'number' | 'date';
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  name?: string;
  readOnly?: boolean;
  required?: boolean;
  disabled?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      // type = 'text',
      value = '',
      onChange,
      placeholder,
      className = '',
      id,
      name,
      required = false,
      disabled,
    },
    ref,
  ) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
      <input
        // type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`p-2 h-[51px] w-full border border-gray-300 rounded shadow-sm ${className} ${isFocused || value ? 'bg-white' : '#e1e1e1'} focus:outline-none`}
        id={id}
        name={name}
        ref={ref}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        required={required}
        disabled={disabled}
      />
    );
  },
);

Input.displayName = 'Input';

export default Input;
